import { PopupStoreLandingPage } from './PopupStoreLanding.page';

export const popupStoreLandingRouter = {
  '/@/popupstore/online': PopupStoreLandingPage,
};
